// extracted by mini-css-extract-plugin
export var container = "MiniCard-module--container--4c205";
export var content = "MiniCard-module--content--dda64";
export var image = "MiniCard-module--image--fac18";
export var info = "MiniCard-module--info--3783a";